"use client";

import React from "react";
import { GoogleReCaptchaProvider } from "@google-recaptcha/react";

interface ReCaptchaProviderProps {
  children: React.ReactNode;
}

export function ReCaptchaProvider({ children }: ReCaptchaProviderProps) {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "";

  if (!siteKey) {
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider type="v2-checkbox" siteKey={siteKey}>
      {children}
    </GoogleReCaptchaProvider>
  );
}
